import type { ButtonVariant, TagColor } from '@billy/design-system'
import { Color } from '@billy/design-system'

import { ImportedInvoicePaymentStatus } from '../types/importedInvoicePaymentStatus'

interface ImportedInvoicePaymentStatusVariant {
  actionKey: string
  actionVariant: ButtonVariant
  labelKey: string
  summaryColor: Color
  tagColor: TagColor
}

export const importedInvoicePaymentStatusToVariant: Record<
  ImportedInvoicePaymentStatus,
  ImportedInvoicePaymentStatusVariant
> = {
  [ImportedInvoicePaymentStatus.Paid]: {
    actionKey: 'imported_invoices.detail.action.void_payment',
    actionVariant: 'outlined',
    labelKey: 'imported_invoices.detail.status.paid',
    summaryColor: Color.Green100,
    tagColor: 'green',
  },
  [ImportedInvoicePaymentStatus.Unpaid]: {
    actionKey: 'imported_invoices.detail.action.register_payment',
    actionVariant: 'filled',
    labelKey: 'imported_invoices.detail.status.unpaid',
    summaryColor: Color.Yellow100,
    tagColor: 'yellow',
  },
}
